import { BasicsSection } from './BasicsSection';
import { AllocationSection } from './AllocationSection';
import { BalancePolicySection } from './BalancePolicySection';
import { TransactionRulesSection } from './TransactionRulesSection';
import { TransactionFieldsSection } from './TransactionFieldsSection';
import './RemittanceTab.css';

export interface RemittanceTabProps {
  /** Threaded down to AllocationSection for the published-target id-lock
   *  (`usePublishedTargetIds`). Optional — omitted callers just lose that
   *  one lock source; the draft-reference locks still apply. */
  jobTypeId?: string;
}

/**
 * SP6 Task 3 — section-composition shell for the Remittance job-config tab.
 * Surface-gated in ../../automations/visible-tabs.ts (REMITTANCE_TAB) and
 * rendered by JobTypeDetailPage alongside AutomationsTab; reads/writes the
 * same singleton draft store (`useFormConfigStore`) that AutomationsTab and
 * every other Job Config section uses — no separate provider/context needed.
 *
 * Renders Basics, Allocation, BalancePolicy, TransactionRules, and
 * TransactionFields as ordered siblings.
 */
export function RemittanceTab({ jobTypeId }: RemittanceTabProps) {
  return (
    <div className="remittance-tab">
      <h2 className="remittance-tab__heading">Remittance</h2>
      <BasicsSection />
      <AllocationSection jobTypeId={jobTypeId} />
      <BalancePolicySection />
      <TransactionRulesSection />
      <TransactionFieldsSection />
    </div>
  );
}
